(() => {
	const setClass = () => {
		if (!CSS.supports('selector(:focus-visible)')) {
			document.documentElement.classList.add('jjk-focus-as-focus-visible');
		}
	};
	if (document.readyState === 'complete') {
		setClass();
	} else {
		document.addEventListener('DOMContentLoaded', () => {
			setClass();
		});
	}
})();
